import React from 'react'
import Footer from '../Footer'
import TickerPrice from '../../../containers/Tickers/TickerPrice'
import TickerPower from '../../../containers/Tickers/TickerPower'
import ModalBS from '../../../containers/ModalBS'
import ReminderBS from '../../../containers/ReminderBS'

const PageLayout6 = ({ children, big, phone, price, power}) =>{

  return(
    <div className='bs-body'>
      <ReminderBS />
      <ModalBS />
      { price ? <TickerPrice /> : null }
      { power ? <TickerPower /> : null }
      <div className="page-layout-6-container">
        { children }
      </div>
      <Footer big={big} phone={phone}/>
    </div>
  )
}

export default PageLayout6
